export const RETURN_TO_PARAM = 'returnTo';

/** Only an in-app path is honoured, so the parameter can never send the user to another site. */
export const safeReturnTo = (value: string | null | undefined): string | null =>
    value && value.startsWith('/') && !value.startsWith('//') && !/[\p{Cc}\\]/u.test(value) ? value : null;

/** `href` carrying the current page as the place its editor's Back returns to. */
export const withReturnTo = (href: string): string => {
    const here = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const url = new URL(href, window.location.origin);
    url.searchParams.set(RETURN_TO_PARAM, here);
    return `${url.pathname}${url.search}${url.hash}`;
};
